import { useCallback, useState } from "react";

import type { PDFSelectTextEvent, PDFTextSelection } from "./helper-types";

import { usePDF } from "./use-pdf";
import { usePDFViewerEvent } from "./use-pdf-viewer-event";

export function usePDFTextSelection() {
  const { events } = usePDF();
  const [textSelection, setTextSelection] = useState<PDFTextSelection | null>(
    null,
  );

  const clearTextSelection = useCallback(() => setTextSelection(null), []);

  const copyTextSelection = useCallback(() => {
    if (textSelection) {
      return navigator.clipboard.writeText(textSelection.text);
    }
  }, [textSelection]);

  usePDFViewerEvent(events?.selectText, (event: PDFSelectTextEvent) => {
    // Possible Foxit bug: In some cases, event.text is an empty string even when text is selected.
    // The correct text can still be found in the `text` field of the first item in `rectArray`.
    const text = event.text || event.rectArray[0]?.text;
    if (text) {
      setTextSelection({
        pageIndex: event.page.info.index,
        text,
        rects: event.rectArray,
      });
    }
  });

  return { textSelection, clearTextSelection, copyTextSelection };
}
